
const globalVariable = process.env.VUE_APP_NAME;


  export default globalVariable

